export default __webpack_public_path__ + "static/media/Products.03fbbbef.png";